module.exports = __webpack_public_path__ + "img/testimonial-expert2.5566d0ca.jpg";